import imageWes from './images/wes.png';
import imageBrandon from './images/brandon.png';
import imageSujata from './images/sujata.png';
import imageOrion from './images/orion.png';

export const AUTHOR_MAP = {
  amc: {
    imageSrc: imageWes,
    description:
      'Your coach Wes Carroll, who authored this course, has helped students master the AMC and reach the AIME for over 20 years. He can help you, too.',
  },
  finra: {
    imageSrc: imageBrandon,
    description:
      'Your coach Brandon Rith has 15+ years of finance and licensing experience. Brandon has helped thousands of people from all backgrounds pass FINRA/NASAA exams.',
  },
  usmle: {
    imageSrc: imageSujata,
    description:
      'Sujata Arecanteparamb, M.D. and founder of GraceUSMLE, is a 250+ USMLE scorer with more than 10 years experience as a Clinician and Medical Tutor. She has taught hundreds of students as a part of GraceUSMLE.',
  },
  gre: {
    imageSrc: imageOrion,
    description:
      'Your coach Orion Taraban, author of this course, the Achievable GRE manual, and creator of the Stellar method has helped thousands of students hit their target scores and gain admission to top-ranked post-graduate programs.',
  },
};
